import EventDomain, { getEventDomain } from '@/entities/enums/eventDomains';
import AppConfig from '@/configLoader';
import EventTypes, { SENSOR_ORDER, SmartPlugSources } from './enums/EventTypes';
import DateTimeManager from '@/services/DateTimeManager';
import i18n from '@/lang/lang';
export default class EventType {
    id;
    type;
    domain;
    name;
    slug;
    icon;
    static UPTIME_ID = 16;
    static FLOOD_ID = 17;
    constructor() { }
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => EventType.define(et));
        }
        else if (data != null) {
            return EventType.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let eventType = new EventType();
        eventType.id = data.Id;
        eventType.type = data.Type;
        eventType.domain = getEventDomain(data.Domain);
        eventType.name = data.Name;
        eventType.slug = data.Slug;
        eventType.icon = this.getIcon(data.Slug);
        return eventType;
    }
    static getIcon(slug) {
        switch (slug) {
            case 'temperature':
                return 'thermometer-half';
                break;
            case 'temperaturetime':
                return 'clock';
                break;
            case 'batterytemperature':
                return 'temperature-high';
                break;
            case 'humidity':
                return 'tint';
                break;
            case 'shock':
                return 'car-crash';
                break;
            case 'battery':
                return 'battery-full';
                break;
            case 'batteryvoltage':
                return 'bolt';
                break;
            case 'acceleration':
                return 'car-crash';
                break;
            case 'pressure':
                return 'tachometer-alt';
                break;
            case 'uptime':
                return 'signal';
                break;
            case 'dewpoint':
                return 'temperature-low';
                break;
            default:
                return 'question';
                break;
        }
    }
    static getSmartPlugIcon(powerSource) {
        if (powerSource == SmartPlugSources.UNKNOWN)
            return 'smartPlug-unknown-icon';
        else if (powerSource == SmartPlugSources.POWER)
            return 'smartPlug-power-icon';
        else if (powerSource == SmartPlugSources.BATTERY)
            return 'smartPlug-battery-icon';
        return 'smartPlug-unknown-icon';
    }
    static addUnits(eventTypes, units) {
        let typesWithUnit = new Array();
        eventTypes.forEach((type) => {
            let typeWithUnit = type;
            typeWithUnit.unit = units[type.type];
            typesWithUnit.push(typeWithUnit);
        });
        return typesWithUnit;
    }
    static getMeasuredEventTypes(eventTypes) {
        return eventTypes.filter((x) => x.domain == EventDomain.MEASURED);
    }
    static filterAvailableMeasuredEventTypes(allTypes) {
        let measuredVirtualQuantities = AppConfig.getConfig().attributes.measured_virtual_quantities;
        return allTypes.filter((x) => x.domain === EventDomain.MEASURED && !measuredVirtualQuantities.includes(x.slug));
    }
    static sortEvents(events) {
        return events.sort((a, b) => {
            const weightA = SENSOR_ORDER.get(a.eventType.slug) ?? 99;
            const weightB = SENSOR_ORDER.get(b.eventType.slug) ?? 99;
            return weightA - weightB;
        });
    }
    /**
     * Static function to format smartPlug data into object
     * powersource can be 0,1,2 based on its source
     * uptime can be in ms or s -> converting to ms
     * in first generation smartplug change is not present
     * @param events - events measured by logger
     * @returns smartPlug object with necessary data
     */
    static getSmartPlugData(events) {
        const sp = events.find((e) => e.eventType.slug === EventTypes.SMARTPLUG_CHANGE);
        const uptime = events.find((e) => e.eventType.slug === EventTypes.UPTIME);
        return {
            powerSource: sp ? sp.value : SmartPlugSources.POWER,
            uptime: uptime ? (uptime.unit == 's' ? uptime.value * 1000 : uptime.value) : null,
            measuredAt: uptime ? uptime.measuredAt * 1000 : null
        };
    }
    static getSmartPlugTooltip(data, includeLabel = true, durationDepth) {
        if (!data)
            return '';
        const sourceKey = data.powerSource === SmartPlugSources.POWER
            ? 'component.last_events.table.smartPlug.onPower'
            : data.powerSource === SmartPlugSources.BATTERY
                ? 'component.last_events.table.smartPlug.onBattery'
                : 'component.last_events.table.smartPlug.unknown';
        const duration = data.uptime != null ? DateTimeManager.formatDurationWithAnchor(data.uptime, data.measuredAt, durationDepth) : '';
        const label = includeLabel ? `${i18n.t('services.smartplugchange')} - ` : '';
        return `${label}${i18n.t(sourceKey)} ${duration}`.trim();
    }
    static hasSmartPlugOutage(powerSource, source) {
        return powerSource == SmartPlugSources.BATTERY || !source.checkIsOnline();
    }
}
export class EventTypeWithUnit extends EventType {
    unit;
}
